import { Injectable } from "@angular/core";
import { Router, CanActivate, RouterStateSnapshot, ActivatedRouteSnapshot } from "@angular/router";
import { MaintenanceModeService } from "../services/http/maintenanceMode.service";

@Injectable()
export class MaintenanceModeGuard implements CanActivate {

  constructor(
    private _router: Router,
    private _maintenanceModeService: MaintenanceModeService) {
  }

  canActivate(_: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this._maintenanceModeService.isMaintenanceModeActive) {
      if (!state.url.startsWith("/maintenanceMode")) {
        this._router.navigate(["maintenanceMode"]);
        return false;
      }
      return true;
    } else {
      if (state.url.startsWith("/maintenanceMode")) {
        this._router.navigate(["/home"]);
        return false;
      }
      return true;
    }
  }
}
